import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ToastContainer } from 'react-toastify';
import { Libraries, LoadScript } from '@react-google-maps/api';

import { AuthenticationRoute, AuthorizationRoute, LanguageRoute, MainRoute, SubscriptionGuard, ValidatedRoute } from './Route';

import HomePage from './home/Home';
import AuthPage from './auth/Auth';
import LoginPage from './auth/Login';
import RegisterPage from './auth/Register';
import RegisterInvitationPage from './auth/RegisterInvitation';
import RecoverPage from './auth/Recover';
import ResetPage from './auth/Reset';
import MainPage from './main/Main';
import WelcomePage from './main/panel/Welcome';
import DashboardPage from './main/panel/Dashboard';
import UserPage from './main/user/User';
import UserViewPage from './main/user/UserView';
import UserUpdatePage from './main/user/UserUpdate';
import CompanyPage from './main/company/Company';
import CompanyViewPage from './main/company/CompanyView';
import CompanyCreatePage from './main/company/CompanyCreate';
import CompanyUpdatePage from './main/company/CompanyUpdate';
import ContactPage from './main/contact/Contact';
import ContactListPage from './main/contact/ContactList';
import ContactViewPage from './main/contact/ContactView';
import ContactEntryPage from './main/contact/ContactEntry';
import ContactCreatePage from './main/contact/ContactCreate';
import TreasuryPage from './main/treasury/Treasury';
import TreasuryListPage from './main/treasury/TreasuryList';
import TreasuryCreatePage from './main/treasury/TreasuryCreate';
import PosPage from './main/pos/Pos';
import PosListPage from './main/pos/PosList';
import PosCreatePage from './main/pos/PosCreate';
import PosViewPage from './main/pos/PosView';
import PosSalePage from './main/pos/sale/PosSale';
import SaleViewPage from './main/pos/sale/SaleView';
import POSCreatePage from './main/pos/sale/PosSaleCreate';
import SalePage from './main/sale/Sale';
import QuotePage from './main/sale/quote/Quote';
import QuoteListPage from './main/sale/quote/QuoteList';
import QuoteViewPage from './main/sale/quote/QuoteView';
import QuoteCreatePage from './main/sale/quote/QuoteCreate';
import QuoteReferencePage from './main/sale/quote/QuoteReference';
import QuoteUpdatePage from './main/sale/quote/QuoteUpdate';
import OrderPage from './main/sale/order/Order';
import OrderListPage from './main/sale/order/OrderList';
import OrderViewPage from './main/sale/order/OrderView';
import OrderCreatePage from './main/sale/order/OrderCreate';
import OrderReferencePage from './main/sale/order/OrderReference';
import OrderUpdatePage from './main/sale/order/OrderUpdate';
import DeliveryNoteViewPage from './main/sale/order/DeliveryNoteView';
import InvoicePage from './main/sale/invoice/Invoice';
import InvoiceListPage from './main/sale/invoice/InvoiceList';
import InvoiceViewPage from './main/sale/invoice/InvoiceView';
import InvoiceCreatePage from './main/sale/invoice/InvoiceCreate';
import InvoiceReferencePage from './main/sale/invoice/InvoiceReference';
import InvoiceUpdatePage from './main/sale/invoice/InvoiceUpdate';
import RecurringContractPage from './main/sale/recurring-contract/RecurringContract';
import RecurringContractListPage from './main/sale/recurring-contract/RecurringContractList';
import RecurringContractViewPage from './main/sale/recurring-contract/RecurringContractView';
import RecurringContractCreatePage from './main/sale/recurring-contract/RecurringContractCreate';
import RecurringContractUpdatePage from './main/sale/recurring-contract/RecurringContractUpdate';
import ConsignmentPage from './main/purchase/consignment/Consignment';
import ConsignmentListPage from './main/purchase/consignment/ConsignmentList';
import ConsignmentCreatePage from './main/purchase/consignment/ConsignmentCreate';
import ConsignmentViewPage from './main/purchase/consignment/ConsignmentView';
import ConsignmentReceivePage from './main/purchase/consignment/ConsignmentReceive';
import ConsignmentReturnPage from './main/purchase/consignment/ConsignmentReturn';
import ConsignmentReportPage from './main/purchase/consignment/ConsignmentReport';
import PurchasePage from './main/purchase/Purchase';
import ProviderQuotePage from './main/purchase/quote/ProviderQuote';
import ProviderQuoteListPage from './main/purchase/quote/ProviderQuoteList';
import ProviderQuoteViewPage from './main/purchase/quote/ProviderQuoteView';
import ProviderOrderPage from './main/purchase/order/ProviderOrder';
import ProviderOrderListPage from './main/purchase/order/ProviderOrderList';
import ProviderOrderViewPage from './main/purchase/order/ProviderOrderView';
import ProviderOrderCreatePage from './main/purchase/order/ProviderOrderCreate';
import ProviderOrderReferencePage from './main/purchase/order/ProviderOrderReference';
import ProviderOrderUpdatePage from './main/purchase/order/ProviderOrderUpdate';
import ProviderInvoicePage from './main/purchase/invoice/ProviderInvoice';
import ProviderInvoiceListPage from './main/purchase/invoice/ProviderInvoiceList';
import ProviderInvoiceViewPage from './main/purchase/invoice/ProviderInvoiceView';
import ProviderInvoiceCreatePage from './main/purchase/invoice/ProviderInvoiceCreate';
import ProviderInvoiceUpdatePage from './main/purchase/invoice/ProviderInvoiceUpdate';
import ProviderInvoiceReferencePage from './main/purchase/invoice/ProviderInvoiceReference';
import ExpensePage from './main/purchase/expense/Expense';
import ExpenseListPage from './main/purchase/expense/ExpenseList';
import ExpenseViewPage from './main/purchase/expense/ExpenseView';
import ExpenseCreatePage from './main/purchase/expense/ExpenseCreate';
import ExpenseUpdatePage from './main/purchase/expense/ExpenseUpdate';
import ExpenseReportPage from './main/purchase/expense-report/ExpenseReport';
import ExpenseReportListPage from './main/purchase/expense-report/ExpenseReportList';
import ExpenseReportViewPage from './main/purchase/expense-report/ExpenseReportView';
import ExpenseReportCreatePage from './main/purchase/expense-report/ExpenseReportCreate';
import ExpenseReportUpdatePage from './main/purchase/expense-report/ExpenseReportUpdate';
import DocumentPage from './main/documents/Document';
import DocumentListPage from './main/documents/DocumentList';
import DocumentViewPage from './main/documents/DocumentView';
import InventoryPage from './main/inventory/Inventory';
import CategoryPage from './main/inventory/category/Category';
import CategoryListPage from './main/inventory/category/CategoryList';
import CategoryViewPage from './main/inventory/category/CategoryView';
import ServicePage from './main/inventory/service/Service';
import ServiceListPage from './main/inventory/service/ServiceList';
import ServiceViewPage from './main/inventory/service/ServiceView';
import ServiceCreatePage from './main/inventory/service/ServiceCreate';
import ServiceUpdatePage from './main/inventory/service/ServiceUpdate';
import ProductPage from './main/inventory/product/Product';
import ProductListPage from './main/inventory/product/ProductList';
import ProductViewPage from './main/inventory/product/ProductView';
import ProductCreatePage from './main/inventory/product/ProductCreate';
import ProductUpdatePage from './main/inventory/product/ProductUpdate';
import StorageCenterPage from './main/inventory/storage/StorageCenter';
import StorageCenterListPage from './main/inventory/storage/StorageCenterList';
import StorageCenterViewPage from './main/inventory/storage/StorageCenterView';
import StorageCenterOperationPage from './main/inventory/storage/StorageCenterOperation';
import AssetPage from './main/inventory/asset/Asset';
import AssetListPage from './main/inventory/asset/AssetList';
import AssetCreatePage from './main/inventory/asset/AssetCreate';
import AssetUpdatePage from './main/inventory/asset/AssetUpdate';
import AssetViewPage from './main/inventory/asset/AssetView';
import AccountingPage from './main/accounting/Accounting';
import JournalPage from './main/accounting/journal/Journal';
import JournalListPage from './main/accounting/journal/JournalList';
import JournalViewPage from './main/accounting/journal/JournalView';
import PlanPage from './main/accounting/plan/Plan';
import PlanListPage from './main/accounting/plan/PlanList';
import PlanViewPage from './main/accounting/plan/PlanView';
import PlanAccountRedirectPage from './main/accounting/plan/PlanAccountRedirect';
import StatementPage from './main/accounting/statement/Statement';
import StatementListPage from './main/accounting/statement/StatementList';
import TicketPendingListPage from './main/accounting/statement/TicketPendingList';
import VatReturnPage from './main/accounting/vat-return/VatReturn';
import VatReturnListPage from './main/accounting/vat-return/VatReturnList';
import VatReturnCasePage from './main/accounting/vat-return/VatReturnCase';
import EntryViewPage from './main/accounting/entry/EntryView';
import OpeningBalancePage from './main/accounting/fiscal-year/OpeningBalance';
import FiscalYearListPage from './main/accounting/fiscal-year/FiscalYearList';
import BalanceSheetPage from './main/accounting/reports/BalanceSheet';
import IncomeStatementPage from './main/accounting/reports/IncomeStatement';
import TrialBalancePage from './main/accounting/reports/TrialBalance';
import BankStatementPage from './main/treasury/bank-statement/BankStatement';
import BankStatementListPage from './main/treasury/bank-statement/BankStatementList';
import BankStatementViewPage from './main/treasury/bank-statement/BankStatementView';
import BankTransactionListPage from './main/treasury/bank-statement/BankTransactionList';
import AdminPage from './main/admin/Admin';
import MemberListPage from './main/admin/MemberList';
import MemberViewPage from './main/admin/MemberView';
import InvitationListPage from './main/admin/InvitationList';
import RoleListPage from './main/admin/RoleList';
import RoleCreatePage from './main/admin/RoleCreate';
import RoleViewPage from './main/admin/RoleView';
import PolicyListPage from './main/admin/PolicyList';
import PolicyCreatePage from './main/admin/PolicyCreate';
import PolicyViewPage from './main/admin/PolicyView';
import SubscriptionPage from './main/admin/Subscription';
import SubscriptionOffersPage from './main/admin/SubscriptionOffers';
import SubscriptionInvoicesPage from './main/admin/SubscriptionInvoices';
import SubscriptionPaymentMethodsPage from './main/admin/SubscriptionPaymentMethods';
import SubscriptionAddonsPage from './main/admin/SubscriptionAddons';
import PaymentPage from './pay/PaymentPage';
import PaymentReturnPage from './pay/PaymentReturnPage';
import AccessPage from './access/Access';
import ValidationPage from './access/Validation';
import InvitationPage from './access/Invitation';
import ComingSoonPage from './page/ComingSoon';
import SystemErrorPage from './page/SystemError';
import NotFoundAccessPage from './page/NotFoundAccess';
import NotFoundAuthPage from './page/NotFoundAuthentication';
import NotFoundMainPage from './page/NotFoundMain';
import NotFoundPage from './page/NotFound';
import ErrorBoundary from './page/ErrorBoundary';

import './App.scss';
import BrandPage from './main/inventory/brand/Brand';
import BrandListPage from './main/inventory/brand/BrandList';
import PayrollPage from './main/payroll/Payroll';
import EmployeeListPage from './main/payroll/EmployeeList';
import EmployeeViewPage from './main/payroll/EmployeeView';
import EmployeeCreatePage from './main/payroll/EmployeeCreate';
import EmployeeEditPage from './main/payroll/EmployeeEdit';
import PayrollAccessDeniedPage from './main/payroll/PayrollAccessDenied';
import PayrollRunListPage from './main/payroll/PayrollRunList';
import PayrollRunViewPage from './main/payroll/PayrollRunView';
import DeclarationPage from './main/payroll/DeclarationPage';

export interface AppPageProps {};

const GOOGLE_LIBRARIES: Libraries = ["places"];

const App: React.FunctionComponent<AppPageProps> = (props) => {
  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string} libraries={GOOGLE_LIBRARIES}>
      <BrowserRouter>
        <Routes>
          <Route element={<LanguageRoute/>}>
            <Route index element={<HomePage/>}/>
            <Route path='/:language' element={<HomePage/>}/>
            <Route path='/auth/*' element={<AuthenticationRoute content={<ErrorBoundary><AuthPage/></ErrorBoundary>}/>}>
              <Route path='login' element={<LoginPage/>}/>
              <Route path='register' element={<RegisterPage/>}/>
              <Route path='register/:email' element={<RegisterPage/>}/>
              <Route path='register/invitation/:token' element={<RegisterInvitationPage/>}/>
              <Route path='recover' element={<RecoverPage/>}/>
              <Route path='reset/:token' element={<ResetPage/>}/>
              <Route path='*' element={<NotFoundAuthPage/>}/>
            </Route>
            <Route path='/:language/auth/*' element={<AuthenticationRoute content={<ErrorBoundary><AuthPage/></ErrorBoundary>}/>}>
              <Route path='login' element={<LoginPage/>}/>
              <Route path='register' element={<RegisterPage/>}/>
              <Route path='register/:email' element={<RegisterPage/>}/>
              <Route path='register/invitation/:token' element={<RegisterInvitationPage/>}/>
              <Route path='recover' element={<RecoverPage/>}/>
              <Route path='reset/:token' element={<ResetPage/>}/>
              <Route path='*' element={<NotFoundAuthPage/>}/>
            </Route>
            <Route path='/main/*' element={<AuthorizationRoute content={<ErrorBoundary><MainPage/></ErrorBoundary>}/>}>
              <Route path='welcome' element={<MainRoute content={<WelcomePage/>} multicompany={false}/>}/>
              <Route path='dashboard' element={<MainRoute content={<DashboardPage/>} multicompany={true}/>}/>
              <Route path='user/*' element={<UserPage/>}>
                <Route path='view' element={<UserViewPage/>}/>
                <Route path='update' element={<UserUpdatePage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='company/*' element={<CompanyPage/>}>
                <Route path='view' element={<ValidatedRoute content={<CompanyViewPage/>}/>}/>
                <Route path='update' element={<ValidatedRoute content={<CompanyUpdatePage/>}/>}/>
                <Route path='create' element={<CompanyCreatePage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='contact/*' element={<ValidatedRoute content={<ContactPage/>}/>}>
                <Route path='list' element={<ContactListPage/>}/>
                <Route path='view/:id' element={<ContactViewPage/>}/>
                <Route path='create' element={<ContactCreatePage/>}/>
                <Route path='entry/:id' element={<ContactEntryPage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='treasury/*' element={<ValidatedRoute content={<TreasuryPage/>}/>}>
                <Route path='list' element={<TreasuryListPage/>}/>
                <Route path='create' element={<TreasuryCreatePage/>}/>
                <Route path='bank-statement/*' element={<BankStatementPage/>}>
                  <Route path='list' element={<BankStatementListPage/>}/>
                  <Route path='view/:id' element={<BankStatementViewPage/>}/>
                  <Route path='transactions' element={<BankTransactionListPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='pos/*' element={<ValidatedRoute content={<PosPage/>}/>}>
                <Route path='list' element={<PosListPage/>}/>
                <Route path='view/:id' element={<PosViewPage/>}/>
                <Route path='create' element={<PosCreatePage/>}/>
                <Route path='sale/*' element={<PosSalePage/>}>
                  <Route path='create/:id' element={<POSCreatePage/>}/>
                  <Route path='view/:id' element={<SaleViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='sale/*' element={<ValidatedRoute content={<SalePage/>}/>}>
                <Route path='quote/*' element={<QuotePage/>}>
                  <Route path='list' element={<QuoteListPage/>}/>
                  <Route path='view/:id' element={<QuoteViewPage/>}/>
                  <Route path='create' element={<QuoteCreatePage/>}/>
                  <Route path='create/reference/:id' element={<QuoteReferencePage/>}/>
                  <Route path='update/:id' element={<QuoteUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='order/*' element={<OrderPage/>}>
                  <Route path='list' element={<OrderListPage/>}/>
                  <Route path='view/:id' element={<OrderViewPage/>}/>
                  <Route path='create' element={<OrderCreatePage/>}/>
                  <Route path='create/reference/:id' element={<OrderReferencePage/>}/>
                  <Route path='update/:id' element={<OrderUpdatePage/>}/>
                  <Route path=':id_order/delivery-note/:id_delivery_note' element={<DeliveryNoteViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='invoice/*' element={<InvoicePage/>}>
                  <Route path='list' element={<InvoiceListPage/>}/>
                  <Route path='view/:id' element={<InvoiceViewPage/>}/>
                  <Route path='create' element={<InvoiceCreatePage/>}/>
                  <Route path='create/reference/:id' element={<InvoiceReferencePage/>}/>
                  <Route path='update/:id' element={<InvoiceUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='recurring-contract/*' element={<RecurringContractPage/>}>
                  <Route path='list' element={<RecurringContractListPage/>}/>
                  <Route path='view/:id' element={<RecurringContractViewPage/>}/>
                  <Route path='create' element={<RecurringContractCreatePage/>}/>
                  <Route path='update/:id' element={<RecurringContractUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='purchase/*' element={<ValidatedRoute content={<PurchasePage/>}/>}>
                <Route path='quote/*' element={<ProviderQuotePage/>}>
                  <Route path='list' element={<ProviderQuoteListPage/>}/>
                  <Route path='view/:id' element={<ProviderQuoteViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='order/*' element={<ProviderOrderPage/>}>
                  <Route path='list' element={<ProviderOrderListPage/>}/>
                  <Route path='view/:id' element={<ProviderOrderViewPage/>}/>
                  <Route path='create' element={<ProviderOrderCreatePage/>}/>
                  <Route path='create/reference/:id' element={<ProviderOrderReferencePage/>}/>
                  <Route path='update/:id' element={<ProviderOrderUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='invoice/*' element={<ProviderInvoicePage/>}>
                  <Route path='list' element={<ProviderInvoiceListPage/>}/>
                  <Route path='view/:id' element={<ProviderInvoiceViewPage/>}/>
                  <Route path='create' element={<ProviderInvoiceCreatePage/>}/>
                  <Route path='create/reference/:id' element={<ProviderInvoiceReferencePage/>}/>
                  <Route path='update/:id' element={<ProviderInvoiceUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='expense/*' element={<ExpensePage/>}>
                  <Route path='list' element={<ExpenseListPage/>}/>
                  <Route path='view/:id' element={<ExpenseViewPage/>}/>
                  <Route path='create' element={<ExpenseCreatePage/>}/>
                  <Route path='update/:id' element={<ExpenseUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='expense-report/*' element={<ExpenseReportPage/>}>
                  <Route path='list' element={<ExpenseReportListPage/>}/>
                  <Route path='view/:id' element={<ExpenseReportViewPage/>}/>
                  <Route path='create' element={<ExpenseReportCreatePage/>}/>
                  <Route path='update/:id' element={<ExpenseReportUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='consignment/*' element={<ConsignmentPage/>}>
                  <Route path='list' element={<ConsignmentListPage/>}/>
                  <Route path='view/:id' element={<ConsignmentViewPage/>}/>
                  <Route path='create' element={<ConsignmentCreatePage/>}/>
                  <Route path='receive/:id' element={<ConsignmentReceivePage/>}/>
                  <Route path='return/:id' element={<ConsignmentReturnPage/>}/>
                  <Route path='report/:id' element={<ConsignmentReportPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='documents/*' element={<ValidatedRoute content={<DocumentPage/>}/>}>
                <Route path='list' element={<DocumentListPage/>}/>
                <Route path='view/:id' element={<DocumentViewPage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='inventory/*' element={<ValidatedRoute content={<InventoryPage/>}/>}>
                <Route path='category/*' element={<CategoryPage/>}>
                  <Route path='list' element={<CategoryListPage/>}/>
                  <Route path='view/:id' element={<CategoryViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='service/*' element={<ServicePage/>}>
                  <Route path='list' element={<ServiceListPage/>}/>
                  <Route path='view/:id' element={<ServiceViewPage/>}/>
                  <Route path='create' element={<ServiceCreatePage/>}/>
                  <Route path='update/:id' element={<ServiceUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='product/*' element={<ProductPage/>}>
                  <Route path='list' element={<ProductListPage/>}/>
                  <Route path='view/:id' element={<ProductViewPage/>}/>
                  <Route path='create' element={<ProductCreatePage/>}/>
                  <Route path='update/:id' element={<ProductUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='storage/*' element={<StorageCenterPage/>}>
                  <Route path='list' element={<StorageCenterListPage/>}/>
                  <Route path='view/:id' element={<StorageCenterViewPage/>}/>
                  <Route path='operation/:id' element={<StorageCenterOperationPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='asset/*' element={<AssetPage/>}>
                  <Route path='list' element={<AssetListPage/>}/>
                  <Route path='create' element={<AssetCreatePage/>}/>
                  <Route path='update/:id' element={<AssetUpdatePage/>}/>
                  <Route path='view/:id' element={<AssetViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='brand/*' element={<BrandPage/>}>
                  <Route path='list' element={<BrandListPage/>}/>
                  {/* <Route path='view/:id' element={<BrandViewPage/>}/> */}
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='accounting/*' element={<ValidatedRoute content={<AccountingPage/>}/>}>
                <Route path='journal/*' element={<JournalPage/>}>
                  <Route path='list' element={<JournalListPage/>}/>
                  <Route path='view/:id' element={<JournalViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='plan/*' element={<PlanPage/>}>
                  <Route path='list' element={<PlanListPage/>}/>
                  <Route path='view/:id' element={<PlanViewPage/>}/>
                  <Route path='account' element={<PlanAccountRedirectPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='statement/*' element={<StatementPage/>}>
                  <Route path='list' element={<StatementListPage/>}/>
                  <Route path='ticket' element={<TicketPendingListPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='vat-return/*' element={<VatReturnPage/>}>
                  <Route path='view/:id_period' element={<VatReturnListPage/>}/>
                  <Route path='view/:id_period/case/:case_code' element={<VatReturnCasePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='entry/view/:id_entry' element={<EntryViewPage/>}/>
                <Route path='fiscal-year/list' element={<FiscalYearListPage/>}/>
                <Route path='fiscal-year/:id_fiscal_year/opening-balance' element={<OpeningBalancePage/>}/>
                <Route path='reports/balance-sheet' element={<BalanceSheetPage/>}/>
                <Route path='reports/income-statement' element={<IncomeStatementPage/>}/>
                <Route path='reports/trial-balance' element={<TrialBalancePage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='admin/*' element={<ValidatedRoute content={<AdminPage/>}/>}>
                <Route path='users' element={<MemberListPage/>}/>
                <Route path='users/:id' element={<MemberViewPage/>}/>
                <Route path='invitations' element={<InvitationListPage/>}/>
                <Route path='subscription' element={<SubscriptionPage/>}/>
                <Route path='subscription/offers' element={<SubscriptionOffersPage/>}/>
                <Route path='subscription/invoices' element={<SubscriptionInvoicesPage/>}/>
                <Route path='subscription/payment-methods' element={<SubscriptionPaymentMethodsPage/>}/>
                <Route path='subscription/addons' element={<SubscriptionAddonsPage/>}/>
                <Route path='roles' element={<RoleListPage/>}/>
                <Route path='roles/create' element={<RoleCreatePage/>}/>
                <Route path='roles/:id' element={<RoleViewPage/>}/>
                <Route path='policies' element={<PolicyListPage/>}/>
                <Route path='policies/create' element={<PolicyCreatePage/>}/>
                <Route path='policies/:id' element={<PolicyViewPage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='payroll/*' element={<SubscriptionGuard action="read" arn="digital:payroll:*" content={<PayrollPage/>} roleFallback={<PayrollAccessDeniedPage reason="role"/>} planFallback={<PayrollAccessDeniedPage reason="plan"/>}/>}>
                <Route path='employees/list' element={<EmployeeListPage/>}/>
                <Route path='employees/view/:id' element={<EmployeeViewPage/>}/>
                <Route path='employees/create' element={<EmployeeCreatePage/>}/>
                <Route path='employees/edit/:id' element={<EmployeeEditPage/>}/>
                <Route path='runs/list' element={<PayrollRunListPage/>}/>
                <Route path='runs/view/:id' element={<PayrollRunViewPage/>}/>
                <Route path='runs/view/:id_run/declaration/:id_employee' element={<DeclarationPage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='*' element={<NotFoundMainPage/>}/>
            </Route>
            <Route path='/:language/main/*' element={<AuthorizationRoute content={<ErrorBoundary><MainPage/></ErrorBoundary>}/>}>
              <Route path='welcome' element={<MainRoute content={<WelcomePage/>} multicompany={false}/>}/>
              <Route path='dashboard' element={<MainRoute content={<DashboardPage/>} multicompany={true}/>}/>
              <Route path='user/*' element={<UserPage/>}>
                <Route path='view' element={<UserViewPage/>}/>
                <Route path='update' element={<UserUpdatePage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='company/*' element={<CompanyPage/>}>
                <Route path='view' element={<ValidatedRoute content={<CompanyViewPage/>}/>}/>
                <Route path='update' element={<ValidatedRoute content={<CompanyUpdatePage/>}/>}/>
                <Route path='create' element={<CompanyCreatePage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='contact/*' element={<ValidatedRoute content={<ContactPage/>}/>}>
                <Route path='list' element={<ContactListPage/>}/>
                <Route path='view/:id' element={<ContactViewPage/>}/>
                <Route path='create' element={<ContactCreatePage/>}/>
                <Route path='entry/:id' element={<ContactEntryPage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='treasury/*' element={<ValidatedRoute content={<TreasuryPage/>}/>}>
                <Route path='list' element={<TreasuryListPage/>}/>
                <Route path='create' element={<TreasuryCreatePage/>}/>
                <Route path='bank-statement/*' element={<BankStatementPage/>}>
                  <Route path='list' element={<BankStatementListPage/>}/>
                  <Route path='view/:id' element={<BankStatementViewPage/>}/>
                  <Route path='transactions' element={<BankTransactionListPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='pos/*' element={<ValidatedRoute content={<PosPage/>}/>}>
                <Route path='list' element={<PosListPage/>}/>
                <Route path='view/:id' element={<PosViewPage/>}/>
                <Route path='create' element={<PosCreatePage/>}/>
                <Route path='sale/*' element={<PosSalePage/>}>
                  <Route path='create/:id' element={<POSCreatePage/>}/>
                  <Route path='view/:id' element={<SaleViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='sale/*' element={<ValidatedRoute content={<SalePage/>}/>}>
                <Route path='quote/*' element={<QuotePage/>}>
                  <Route path='list' element={<QuoteListPage/>}/>
                  <Route path='view/:id' element={<QuoteViewPage/>}/>
                  <Route path='create' element={<QuoteCreatePage/>}/>
                  <Route path='create/reference/:id' element={<QuoteReferencePage/>}/>
                  <Route path='update/:id' element={<QuoteUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='order/*' element={<OrderPage/>}>
                  <Route path='list' element={<OrderListPage/>}/>
                  <Route path='view/:id' element={<OrderViewPage/>}/>
                  <Route path='create' element={<OrderCreatePage/>}/>
                  <Route path='create/reference/:id' element={<OrderReferencePage/>}/>
                  <Route path='update/:id' element={<OrderUpdatePage/>}/>
                  <Route path=':id_order/delivery-note/:id_delivery_note' element={<DeliveryNoteViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='invoice/*' element={<InvoicePage/>}>
                  <Route path='list' element={<InvoiceListPage/>}/>
                  <Route path='view/:id' element={<InvoiceViewPage/>}/>
                  <Route path='create' element={<InvoiceCreatePage/>}/>
                  <Route path='create/reference/:id' element={<InvoiceReferencePage/>}/>
                  <Route path='update/:id' element={<InvoiceUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='recurring-contract/*' element={<RecurringContractPage/>}>
                  <Route path='list' element={<RecurringContractListPage/>}/>
                  <Route path='view/:id' element={<RecurringContractViewPage/>}/>
                  <Route path='create' element={<RecurringContractCreatePage/>}/>
                  <Route path='update/:id' element={<RecurringContractUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='purchase/*' element={<ValidatedRoute content={<PurchasePage/>}/>}>
                <Route path='quote/*' element={<ProviderQuotePage/>}>
                  <Route path='list' element={<ProviderQuoteListPage/>}/>
                  <Route path='view/:id' element={<ProviderQuoteViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='order/*' element={<ProviderOrderPage/>}>
                  <Route path='list' element={<ProviderOrderListPage/>}/>
                  <Route path='view/:id' element={<ProviderOrderViewPage/>}/>
                  <Route path='create' element={<ProviderOrderCreatePage/>}/>
                  <Route path='create/reference/:id' element={<ProviderOrderReferencePage/>}/>
                  <Route path='update/:id' element={<ProviderOrderUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='invoice/*' element={<ProviderInvoicePage/>}>
                  <Route path='list' element={<ProviderInvoiceListPage/>}/>
                  <Route path='view/:id' element={<ProviderInvoiceViewPage/>}/>
                  <Route path='create' element={<ProviderInvoiceCreatePage/>}/>
                  <Route path='create/reference/:id' element={<ProviderInvoiceReferencePage/>}/>
                  <Route path='update/:id' element={<ProviderInvoiceUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='expense/*' element={<ExpensePage/>}>
                  <Route path='list' element={<ExpenseListPage/>}/>
                  <Route path='view/:id' element={<ExpenseViewPage/>}/>
                  <Route path='create' element={<ExpenseCreatePage/>}/>
                  <Route path='update/:id' element={<ExpenseUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='expense-report/*' element={<ExpenseReportPage/>}>
                  <Route path='list' element={<ExpenseReportListPage/>}/>
                  <Route path='view/:id' element={<ExpenseReportViewPage/>}/>
                  <Route path='create' element={<ExpenseReportCreatePage/>}/>
                  <Route path='update/:id' element={<ExpenseReportUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='consignment/*' element={<ConsignmentPage/>}>
                  <Route path='list' element={<ConsignmentListPage/>}/>
                  <Route path='view/:id' element={<ConsignmentViewPage/>}/>
                  <Route path='create' element={<ConsignmentCreatePage/>}/>
                  <Route path='receive/:id' element={<ConsignmentReceivePage/>}/>
                  <Route path='return/:id' element={<ConsignmentReturnPage/>}/>
                  <Route path='report/:id' element={<ConsignmentReportPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='documents/*' element={<ValidatedRoute content={<DocumentPage/>}/>}>
                <Route path='list' element={<DocumentListPage/>}/>
                <Route path='view/:id' element={<DocumentViewPage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='inventory/*' element={<ValidatedRoute content={<InventoryPage/>}/>}>
                <Route path='category/*' element={<CategoryPage/>}>
                  <Route path='list' element={<CategoryListPage/>}/>
                  <Route path='view/:id' element={<CategoryViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='service/*' element={<ServicePage/>}>
                  <Route path='list' element={<ServiceListPage/>}/>
                  <Route path='view/:id' element={<ServiceViewPage/>}/>
                  <Route path='create' element={<ServiceCreatePage/>}/>
                  <Route path='update/:id' element={<ServiceUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='product/*' element={<ProductPage/>}>
                  <Route path='list' element={<ProductListPage/>}/>
                  <Route path='view/:id' element={<ProductViewPage/>}/>
                  <Route path='create' element={<ProductCreatePage/>}/>
                  <Route path='update/:id' element={<ProductUpdatePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='storage/*' element={<StorageCenterPage/>}>
                  <Route path='list' element={<StorageCenterListPage/>}/>
                  <Route path='view/:id' element={<StorageCenterViewPage/>}/>
                  <Route path='operation/:id' element={<StorageCenterOperationPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='asset/*' element={<AssetPage/>}>
                  <Route path='list' element={<AssetListPage/>}/>
                  <Route path='create' element={<AssetCreatePage/>}/>
                  <Route path='update/:id' element={<AssetUpdatePage/>}/>
                  <Route path='view/:id' element={<AssetViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='brand/*' element={<BrandPage/>}>
                  <Route path='list' element={<BrandListPage/>}/>
                  {/* <Route path='view/:id' element={<BrandViewPage/>}/> */}
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='accounting/*' element={<ValidatedRoute content={<AccountingPage/>}/>}>
                <Route path='journal/*' element={<JournalPage/>}>
                  <Route path='list' element={<JournalListPage/>}/>
                  <Route path='view/:id' element={<JournalViewPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='plan/*' element={<PlanPage/>}>
                  <Route path='list' element={<PlanListPage/>}/>
                  <Route path='view/:id' element={<PlanViewPage/>}/>
                  <Route path='account' element={<PlanAccountRedirectPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='statement/*' element={<StatementPage/>}>
                  <Route path='list' element={<StatementListPage/>}/>
                  <Route path='ticket' element={<TicketPendingListPage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='vat-return/*' element={<VatReturnPage/>}>
                  <Route path='view/:id_period' element={<VatReturnListPage/>}/>
                  <Route path='view/:id_period/case/:case_code' element={<VatReturnCasePage/>}/>
                  <Route path='*' element={<NotFoundMainPage/>}/>
                </Route>
                <Route path='entry/view/:id_entry' element={<EntryViewPage/>}/>
                <Route path='fiscal-year/list' element={<FiscalYearListPage/>}/>
                <Route path='fiscal-year/:id_fiscal_year/opening-balance' element={<OpeningBalancePage/>}/>
                <Route path='reports/balance-sheet' element={<BalanceSheetPage/>}/>
                <Route path='reports/income-statement' element={<IncomeStatementPage/>}/>
                <Route path='reports/trial-balance' element={<TrialBalancePage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='admin/*' element={<ValidatedRoute content={<AdminPage/>}/>}>
                <Route path='users' element={<MemberListPage/>}/>
                <Route path='users/:id' element={<MemberViewPage/>}/>
                <Route path='invitations' element={<InvitationListPage/>}/>
                <Route path='subscription' element={<SubscriptionPage/>}/>
                <Route path='subscription/offers' element={<SubscriptionOffersPage/>}/>
                <Route path='subscription/invoices' element={<SubscriptionInvoicesPage/>}/>
                <Route path='subscription/payment-methods' element={<SubscriptionPaymentMethodsPage/>}/>
                <Route path='subscription/addons' element={<SubscriptionAddonsPage/>}/>
                <Route path='roles' element={<RoleListPage/>}/>
                <Route path='roles/create' element={<RoleCreatePage/>}/>
                <Route path='roles/:id' element={<RoleViewPage/>}/>
                <Route path='policies' element={<PolicyListPage/>}/>
                <Route path='policies/create' element={<PolicyCreatePage/>}/>
                <Route path='policies/:id' element={<PolicyViewPage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='payroll/*' element={<SubscriptionGuard action="read" arn="digital:payroll:*" content={<PayrollPage/>} roleFallback={<PayrollAccessDeniedPage reason="role"/>} planFallback={<PayrollAccessDeniedPage reason="plan"/>}/>}>
                <Route path='employees/list' element={<EmployeeListPage/>}/>
                <Route path='employees/view/:id' element={<EmployeeViewPage/>}/>
                <Route path='employees/create' element={<EmployeeCreatePage/>}/>
                <Route path='employees/edit/:id' element={<EmployeeEditPage/>}/>
                <Route path='runs/list' element={<PayrollRunListPage/>}/>
                <Route path='runs/view/:id' element={<PayrollRunViewPage/>}/>
                <Route path='*' element={<NotFoundMainPage/>}/>
              </Route>
              <Route path='*' element={<NotFoundMainPage/>}/>
            </Route>
            <Route path='/pay/:token' element={<PaymentPage/>}/>
            <Route path='/pay/:token/return' element={<PaymentReturnPage/>}/>
            <Route path='/access/*' element={<AccessPage/>}>
              <Route path='validation/user/:token' element={<ValidationPage/>}/>
              <Route path='invitation/company/:token' element={<InvitationPage/>}/>
              <Route path='*' element={<NotFoundAccessPage/>}/>
            </Route>
            <Route path='/:language/access/*' element={<AccessPage/>}>
              <Route path='validation/user/:token' element={<ValidationPage/>}/>
              <Route path='invitation/company/:token' element={<InvitationPage/>}/>
              <Route path='*' element={<NotFoundAccessPage/>}/>
            </Route>
            <Route path='/coming/soon' element={<ComingSoonPage/>}/>
            <Route path='/:language/coming/soon' element={<ComingSoonPage/>}/>
            <Route path='/error' element={<SystemErrorPage/>}/>
            <Route path='/:language/error' element={<SystemErrorPage/>}/>
            <Route path='*' element={<NotFoundPage/>}/>
          </Route>
        </Routes>
        <Toaster position="bottom-right" reverseOrder={true} toastOptions={{style: {borderRadius: '10px'}}}/>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover={false} closeButton={false} theme="dark" toastClassName="mw-300px"/>
      </BrowserRouter>
    </LoadScript>
  );
}

export default App;
